export function formatScore(value?: number | null): string {
  if (value === null || value === undefined || Number.isNaN(value)) return '\u2014'
  const normalized = Object.is(value, -0) ? 0 : value
  return new Intl.NumberFormat().format(Math.trunc(normalized))
}

export function formatRelativeTime(input?: string | null): string {
  if (!input) return 'Unknown'
  const dt = new Date(input)
  if (Number.isNaN(dt.getTime())) return 'Unknown'

  const seconds = Math.max(0, Math.floor((Date.now() - dt.getTime()) / 1000))
  if (seconds < 60) return `${seconds}s ago`
  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return `${minutes}m ago`
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `${hours}h ago`
  const days = Math.floor(hours / 24)
  if (days < 30) return `${days}d ago`
  return dt.toLocaleString()
}

